<main class="landing">

  <section class="hero">
    <div class="hero__logo-wrap">
      <img src="./assets/img/rightbin_logo_text.svg" alt="Rightbin" class="hero__logo">
      <span class="hero__tm" aria-label="trademark">&#8482;</span>
    </div>
    <h1 class="hero__headline">Real-time waste intelligence for modern buildings.</h1>
    <p class="hero__sub">Track tenant greenhouse gas impact and turn disposal data into actionable ESG reporting.</p>
    <a mat-flat-button routerLink="/login" class="hero__cta">Sign In</a>
  </section>

  <section class="features">
    <div class="feature">
      <img src="./assets/img/recycling_icon.png" alt="" aria-hidden="true" class="feature__icon">
      <h2 class="feature__title">Scale Integration</h2>
      <p class="feature__body">Connects directly to your dock scale over USB serial. Weights are captured automatically, with volume-to-weight conversion for containers measured by estimate.</p>
    </div>
    <div class="feature">
      <img src="./assets/img/landfill_icon.png" alt="" aria-hidden="true" class="feature__icon">
      <h2 class="feature__title">Tenant-Level Tracking</h2>
      <p class="feature__body">Log each collection by location and container type. Know exactly where your waste and recyclables are coming from.</p>
    </div>
    <div class="feature">
      <img src="./assets/img/compost_icon.png" alt="" aria-hidden="true" class="feature__icon">
      <h2 class="feature__title">ESG Reporting</h2>
      <p class="feature__body">Get daily diversion rates and greenhouse gas impact broken down by tenant. Share progress with tenants and partners automatically.</p>
    </div>
    <div class="feature">
      <img src="./assets/img/large_compost_bin_icon.png" alt="" aria-hidden="true" class="feature__icon">
      <h2 class="feature__title">Vendor Connections</h2>
      <p class="feature__body">Connect tenants to compost, reuse, and recycling vendors in your building. Close the loop on every waste stream.</p>
    </div>
    <div class="feature">
      <img src="./assets/img/officepaper_icon.png" alt="" aria-hidden="true" class="feature__icon">
      <h2 class="feature__title">Tenant Outreach</h2>
      <p class="feature__body">Turn disposal data into targeted tenant communications. Give every occupant the information they need to improve.</p>
    </div>
    <div class="feature">
      <img src="./assets/img/glass_icon.png" alt="" aria-hidden="true" class="feature__icon">
      <h2 class="feature__title">Diversion Reports</h2>
      <p class="feature__body">Track diversion rates across every waste stream — landfill, recycling, compost, and reuse — updated daily.</p>
    </div>
    <div class="feature">
      <img src="./assets/img/electronics_icon.png" alt="" aria-hidden="true" class="feature__icon">
      <h2 class="feature__title">Gap &amp; Opportunity Analysis</h2>
      <p class="feature__body">Identify underperforming streams and untapped diversion opportunities with data-driven analysis across your building's waste profile.</p>
    </div>
    <div class="feature">
      <img src="./assets/img/can_icon.png" alt="" aria-hidden="true" class="feature__icon">
      <h2 class="feature__title">Slack &amp; Teams Integration</h2>
      <p class="feature__body">Deliver AI-assisted diversion updates and alerts directly to tenant channels in Slack and Microsoft Teams — where your occupants already work.</p>
    </div>
    <div class="feature">
      <img src="./assets/img/cardboard_icon.png" alt="" aria-hidden="true" class="feature__icon">
      <h2 class="feature__title">Earth Month Contests</h2>
      <p class="feature__body">Run annual waste diversion competitions across tenants every April. Friendly leaderboards drive real behavior change when it matters most.</p>
    </div>
  </section>

  <section class="cta">
    <p class="cta__text">Ready to put your waste data to work?</p>
    <div class="cta__actions">
      <a mat-flat-button routerLink="/contact" class="cta__contact">Contact Sales</a>
      <a mat-stroked-button routerLink="/login" class="cta__link">Sign In to Rightbin&#8482;</a>
    </div>
  </section>

</main>
